import React, { useEffect, useState } from 'react';
import BrowserFrame from './BrowserFrame';

const LiveDashboard: React.FC = () => {
  const [tick, setTick] = useState(0);

  useEffect(() => {
    const id = setInterval(() => setTick((t) => t + 1), 1600);
    return () => clearInterval(id);
  }, []);

  const baseRevenue = 48230;
  const revenue = baseRevenue + (tick % 12) * 37;
  const users = 1204 + (tick % 8);
  const orders = 342 + (tick % 5);

  const curvePoints = [6, 14, 10, 22, 18, 28, 24, 34, 30, 42, 38, 48];
  const shifted = [...curvePoints.slice(tick % curvePoints.length), ...curvePoints.slice(0, tick % curvePoints.length)];
  const pathD = shifted
    .map((y, i) => `${i === 0 ? 'M' : 'L'} ${(i / (shifted.length - 1)) * 280} ${60 - y}`)
    .join(' ');

  return (
    <BrowserFrame url="miid.app/ops/live">
      <div style={{ padding: '1rem', background: 'var(--cream)', minHeight: '260px', fontFamily: "'Montserrat', sans-serif" }}>
        {/* Top bar */}
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '.9rem' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '.6rem' }}>
            <div style={{ fontSize: '.72rem', fontWeight: 600, color: 'var(--ink)' }}>Supervision Ops</div>
            <div style={{ display: 'inline-flex', alignItems: 'center', gap: '.3rem', padding: '.15rem .4rem', background: 'rgba(46,125,50,.12)', borderRadius: '3px' }}>
              <span
                style={{
                  width: '6px',
                  height: '6px',
                  borderRadius: '50%',
                  background: '#2E7D32',
                  animation: 'livePulse 1.4s ease-in-out infinite',
                }}
              />
              <span style={{ fontSize: '.48rem', fontWeight: 700, color: '#2E7D32', letterSpacing: '.1em' }}>LIVE</span>
            </div>
          </div>
          <div style={{ fontSize: '.52rem', color: 'var(--ink2)' }}>Mis à jour il y a {(tick % 3) + 1}s</div>
        </div>

        {/* KPI row */}
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '.5rem', marginBottom: '.9rem' }}>
          {[
            { label: 'Revenu', value: `€${revenue.toLocaleString('fr')}`, trend: '+12.4%', color: 'var(--blue)' },
            { label: 'Utilisateurs', value: users.toLocaleString('fr'), trend: '+3.2%', color: 'var(--gold)' },
            { label: 'Commandes', value: orders, trend: '+8.1%', color: '#2E7D32' },
          ].map((k) => (
            <div key={k.label} style={{ background: 'var(--white)', border: '1px solid var(--border)', padding: '.55rem .65rem', borderRadius: '4px' }}>
              <div style={{ fontSize: '.45rem', color: 'var(--ink2)', letterSpacing: '.08em', textTransform: 'uppercase', marginBottom: '.25rem' }}>
                {k.label}
              </div>
              <div style={{ fontSize: '.85rem', fontWeight: 700, color: 'var(--ink)', fontFamily: "'Cormorant Garamond', serif", lineHeight: 1 }}>
                {k.value}
              </div>
              <div style={{ fontSize: '.45rem', fontWeight: 600, color: k.color, marginTop: '.2rem' }}>▲ {k.trend}</div>
            </div>
          ))}
        </div>

        {/* Chart + heatmap */}
        <div style={{ display: 'grid', gridTemplateColumns: '2fr 1fr', gap: '.5rem' }}>
          {/* Chart */}
          <div style={{ background: 'var(--white)', border: '1px solid var(--border)', padding: '.6rem', borderRadius: '4px' }}>
            <div style={{ fontSize: '.5rem', color: 'var(--ink2)', marginBottom: '.3rem', letterSpacing: '.08em', textTransform: 'uppercase' }}>
              Trafic temps réel
            </div>
            <svg viewBox="0 0 280 60" style={{ width: '100%', height: '60px' }}>
              <defs>
                <linearGradient id="liveGrad" x1="0" y1="0" x2="0" y2="1">
                  <stop offset="0%" stopColor="var(--blue)" stopOpacity=".35" />
                  <stop offset="100%" stopColor="var(--blue)" stopOpacity="0" />
                </linearGradient>
              </defs>
              <path d={`${pathD} L 280 60 L 0 60 Z`} fill="url(#liveGrad)" />
              <path d={pathD} stroke="var(--blue)" strokeWidth="1.5" fill="none" strokeLinecap="round" strokeLinejoin="round" />
              {shifted.map((y, i) => (
                <circle key={i} cx={(i / (shifted.length - 1)) * 280} cy={60 - y} r={i === shifted.length - 1 ? 3 : 0} fill="var(--gold)">
                  {i === shifted.length - 1 && (
                    <animate attributeName="r" values="3;5;3" dur="1.4s" repeatCount="indefinite" />
                  )}
                </circle>
              ))}
            </svg>
          </div>

          {/* Heatmap */}
          <div style={{ background: 'var(--white)', border: '1px solid var(--border)', padding: '.6rem', borderRadius: '4px' }}>
            <div style={{ fontSize: '.5rem', color: 'var(--ink2)', marginBottom: '.35rem', letterSpacing: '.08em', textTransform: 'uppercase' }}>Activité</div>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(7, 1fr)', gap: '2px' }}>
              {Array.from({ length: 28 }).map((_, i) => {
                const intensity = ((i * 7 + tick) % 10) / 10;
                return (
                  <div
                    key={i}
                    style={{
                      aspectRatio: '1',
                      background: `rgba(26,111,168,${0.1 + intensity * 0.75})`,
                      borderRadius: '1.5px',
                      transition: 'background .6s ease',
                    }}
                  />
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </BrowserFrame>
  );
};

export default LiveDashboard;
